<template>
    <div class="search-page">
        <div class="sub-container">
            <h1>{{ $t('search') }}</h1>
            <form :action="$store.state.hrefPrefix + '/search'" method="get">
                <div class="search-row">
                    <div class="search-input">
                        <input type="text" :placeholder="$t('search')" name="filter" id="filter" v-model="filter"/>
                        <input style="display: none" v-if="selectedDates != null" type="text" name="start_date"
                               v-model="selectedDates.startDate"/>
                        <input style="display: none" v-if="selectedDates != null" type="text" name="end_date"
                               v-model="selectedDates.endDate"/>
                        <input style="display: none" type="text" name="date_value" v-model="selectedDateValue"/>
                        <input style="display: none" type="text" name="keyword" v-model="selectedTopic"/>
                        <input style="display: none" type="text" name="sort_by" v-model="sortBy"/>
                    </div>
                    <i class="msite-filetr"><img src="/assets/images/search-filter.svg" alt=""/></i>
                    <div class="search-date">
                        <div class="search-date-row">
                            <label>{{ $t('date') }}</label>
                            <select dir="ltr" v-model="selectedDateValue">
                                <option value="all">{{ $t('all_dates') }} </option>
                                <option value="today">{{ $t('today') }}</option>
                                <option value="last7Days">{{ $t('last_7_days') }} </option>
                                <option value="last30Days">{{ $t('last_30_days') }} </option>
                            </select>
                        </div>
                        <div class="search-date-row">
                            <label>{{ $t('topic') }}</label>
                            <select dir="ltr" v-model="selectedTopic">
                                <option value="">{{ $t('all') }}</option>
                                <option v-for="keyword in keywords" :value="keyword.slug">
                                    {{ keyword.keyword_languages[0].pivot.name }}
                                </option>
                            </select>
                        </div>
                        <button class="apply-btn">{{ $t('apply') }}</button>
                    </div>
                    <div class="search-btn">
                        <button type="submit" ref="searchButton">{{ $t('search') }} </button>
                    </div>
                </div>

            </form>
            <div class="search-result">
                <div class="search-result-top">
                    <span v-if="searchArticles.data.length > 0">
                        {{ $t('results') }}
                    </span>
                    <div class="sort-by">
                        <p>{{ $t('sort_by') }}</p>
                        <select dir="ltr" v-model="sortBy" @change="$refs.searchButton.click()">
                            <option value="newest">{{ $t('newest') }}</option>
                            <option value="oldest">{{ $t('oldest') }}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12" v-for="article in searchArticles.data">
                        <search-articles :article="article"></search-articles>

                    </div>
                </div>
                <div class="pagination-row pagination-simple"
                     v-if="searchArticles.prev_page_url || searchArticles.next_page_url">
                    <a class="paginate-link" v-if="searchArticles.prev_page_url"
                       :href="searchArticles.prev_page_url">{{ $t('previous') }}</a>
                    <p class="active">{{ searchArticles.current_page }}</p>
                    <a class="paginate-link" v-if="searchArticles.next_page_url"
                       :href="searchArticles.next_page_url">{{ $t('next') }}</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>


import SearchArticles from "@/parts/SearchArticles.vue";
import moment from "moment";

export default {
    name: "SearchPage",
    components: {SearchArticles},
    props: {
        searchArticles: {
            type: Object,
            default: []
        },
        keywords: {
            type: Array,
            default: []
        }
    },
    computed: {
        selectedDates() {
            if (this.selectedDateValue === 'all') {
                return null;
            }
            if (this.selectedDateValue === 'today') {
                return {
                    startDate: moment().format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                }
            }
            if (this.selectedDateValue === 'last7Days') {
                return {
                    startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                }
            }
            if (this.selectedDateValue === 'last30Days') {
                return {
                    startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                }
            }
        }
    },

    data() {
        return {
            //Get from query param
            filter: null,
            selectedDateValue: 'all',
            selectedTopic: null,
            sortBy: 'newest'
        }
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        this.filter = urlParams.get('filter');
        this.selectedTopic = urlParams.get('keyword') ?? '';
        this.sortBy = urlParams.get('sort_by') ?? 'newest';
        if (urlParams.get('start_date') && urlParams.get('end_date')) {
            this.selectedDateValue = urlParams.get('date_value') ?? 'all';
            this.selectedDates = {
                startDate: urlParams.get('start_date'),
                endDate: urlParams.get('end_date')
            }
        }
    }
}
</script>

<style scoped>

</style>
